<div class="modal-header" [ngClass]="{'bg-danger error-header ': hasError,'warning-text':hasWarning}">
    <div class="error-text" *ngIf="hasError">
        Error
    </div>
	<div  *ngIf="hasWarning">
       <h4>Warning</h4>
    </div>
	<h4 *ngIf="!hasError && !hasWarning">
        Confirmation
    </h4>
	<button type="button" class="close" aria-label="Close" (click)="close()" *ngIf="showClose">
		<span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
	<p class="message-container" [innerHTML]="data"></p>
</div>
<div class="modal-footer">
    <button mat-raised-button type="button" color="btnprimary" (click)="close(true)" *ngIf="showCancel" class="mr-4">
        Modify
	</button>
	<button mat-raised-button type="button" color="btnwhite" (click)="close()" *ngIf="showClose">
        {{ labelButton }}
	</button>
</div>
